document.addEventListener('DOMContentLoaded', () => {
    const cartContainer = document.querySelector('.js-cart-number');
    if(cartContainer){
        let headers = new Headers();
        headers.append('pragma', 'no-cache');
        headers.append('cache-control', 'no-cache');

        let init = {
            method: 'GET',
            headers: headers,
        };

        fetch('/shoppingcart/itemscount', init).then((response) => {
            return response.text();
        }).then((cartReponse) => {
            cartContainer.innerText = cartReponse;
        })
    }
});
